import React, { useState } from 'react';
import { TextField, Grid, Typography, FormControlLabel, Checkbox, Divider } from '@mui/material';
import { useOutletContext } from 'react-router-dom';

const AddressStep = () => {
    const { formData, handleInputChange, setFormData } = useOutletContext();
    const data = formData.address || {};
    const [sameAsResidential, setSameAsResidential] = useState(false);

    const handleSameAsChange = (e) => {
        const isChecked = e.target.checked;
        setSameAsResidential(isChecked);
        
        if (isChecked) {
            // Copy residential fields to postal fields
            setFormData(prev => ({
                ...prev,
                address: {
                    ...prev.address,
                    postalBox: prev.address.physicalStreet,
                    postalCity: prev.address.physicalCity,
                    postalCode: prev.address.physicalCode
                }
            }));
        }
    };

    return (
        <>
            <Typography variant="h6" gutterBottom>3. Address Details</Typography>
            
            <Typography variant="subtitle1" color="primary" sx={{ mt: 2, mb: 1 }}>Residential Address</Typography>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <TextField name="physicalStreet" label="Street Address" fullWidth value={data.physicalStreet || ''} onChange={(e) => handleInputChange('address', e)} required />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField name="physicalSuburb" label="Suburb" fullWidth value={data.physicalSuburb || ''} onChange={(e) => handleInputChange('address', e)} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField name="physicalCity" label="City" fullWidth value={data.physicalCity || ''} onChange={(e) => handleInputChange('address', e)} required />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField name="physicalCode" label="Postal Code" fullWidth value={data.physicalCode || ''} onChange={(e) => handleInputChange('address', e)} required />
                </Grid>
            </Grid>

            <Divider sx={{ my: 3 }} />

            <Typography variant="subtitle1" color="primary" sx={{ mb: 1 }}>Postal Address</Typography>
            <FormControlLabel
                control={<Checkbox checked={sameAsResidential} onChange={handleSameAsChange} />}
                label="Same as Residential Address"
                sx={{ mb: 2 }}
            />

            {!sameAsResidential && (
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <TextField name="postalBox" label="P.O. Box / Street" fullWidth value={data.postalBox || ''} onChange={(e) => handleInputChange('address', e)} required />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField name="postalCity" label="City" fullWidth value={data.postalCity || ''} onChange={(e) => handleInputChange('address', e)} required />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField name="postalCode" label="Postal Code" fullWidth value={data.postalCode || ''} onChange={(e) => handleInputChange('address', e)} required />
                    </Grid>
                </Grid>
            )}
        </>
    );
};

export default AddressStep;